
export default [
    {
        path: '/app/settings',
        name: 'app.settings',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-settings" */ './../views/App/Settings/Dashboard.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/settings/clients',
        name: 'app.settings.clients',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-settings-clients" */ './../views/App/Settings/Clients/Index.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C']
        }
    },
    {
        path: '/app/settings/clients/create',
        name: 'app.settings.clients.create',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-settings-clients-create" */ './../views/App/Settings/Clients/Create.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C']
        }
    },
    {
        path: '/app/settings/clients/edit/:id',
        name: 'app.settings.clients.edit',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-settings-clients-edit" */ './../views/App/Settings/Clients/Edit.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C']
        }
    },
    {
        path: '/app/settings/company',
        name: 'app.settings.company',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-settings-company" */ './../views/App/Settings/Company/Index.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A']
        }
    },
    {
        path: '/app/settings/message-default',
        name: 'app.settings.messagedefault',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-settings-messagedefault" */ './../views/App/Settings/MessageDefault/Index.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/settings/message-default/create',
        name: 'app.settings.messagedefault.create',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-settings-messagedefault-create" */ './../views/App/Settings/MessageDefault/Create.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/settings/message-default/edit/:id',
        name: 'app.settings.messagedefault.edit',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-settings-messagedefault-edit" */ './../views/App/Settings/MessageDefault/Edit.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/settings/users',
        name: 'app.settings.users',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-settings-users" */ './../views/App/Settings/Users/Index.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A']
        }
    },
    {
        path: '/app/settings/users/create',
        name: 'app.settings.users.create',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-settings-users-create" */ './../views/App/Settings/Users/Create.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A']
        }
    },
    {
        path: '/app/settings/users/edit/:id',
        name: 'app.settings.users.edit',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-settings-users-edit" */ './../views/App/Settings/Users/Edit.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A']
        }
    },
    {
        path: '/app/settings/costs',
        name: 'app.settings.costs',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-settings-costs" */ './../views/App/Settings/Costs/Index.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/settings/credits',
        name: 'app.settings.credits',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-settings-credits" */ './../views/App/Settings/Credits/Index.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C']
        }
    },
    {
        path: '/app/settings/extract',
        name: 'app.settings.extract',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-settings-extract" */ './../views/App/Settings/Extracts/Index.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A']
        }
    }
]
